import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

interface UsePermissionGuardOptions {
  enabled: boolean;
  allowed: boolean;
  message: string;
  redirectTo?: string;
}

export const usePermissionGuard = ({
  enabled,
  allowed,
  message,
  redirectTo = '/',
}: UsePermissionGuardOptions) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!enabled || allowed) return;

    toast.error(message);
    navigate(redirectTo, { replace: true });
  }, [allowed, enabled, message, navigate, redirectTo]);
};
